import { create } from 'zustand'

export const useUpdateVisaBulletinInfoDialogStore = create<{
  isDialogOpen: boolean
  openDialog: VoidFunction
  closeDialog: VoidFunction
}>((set) => ({
  isDialogOpen: false,
  openDialog: () => set({ isDialogOpen: true }),
  closeDialog: () => set({ isDialogOpen: false }),
}))
